// src/Reducers/GlobalVar.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalState {
    token: { token: string } | null;
    profileData: any | null;
    showMenu: string | null;
}

const initialState: GlobalState = {
    token: null,
    profileData: null,
    showMenu: null
};

const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<{ token: string }>) => {
            state.token = action.payload;
        },
        setProfileData: (state, action: PayloadAction<{ profileData: any }>) => {
            state.profileData = action.payload;
        },
        clearProfileData: (state) => {
            state.profileData = null;
        },
        clearToken: (state) => {
            state.token = null;
        },
        setShowMenu: (state, action: PayloadAction<string>) => {
            state.showMenu = action.payload;
        },
        clearShowMenu: (state) => {
            state.showMenu = null;
        },
    },
});

export const { setToken, clearToken, setShowMenu, setProfileData, clearProfileData, clearShowMenu } = globalSlice.actions;
export default globalSlice.reducer;
